// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48c7591c","455":"584c10a0","977":"98880759"}[chunkId] + ".chunk.js";
};